'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconTimeClockCircle = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0zm5.2 17.221a1.016 1.016 0 0 1-1.413.062l-4.959-4.546A1 1 0 0 1 10.5 12V6.5a1 1 0 0 1 2 0v5.06l4.634 4.248a1 1 0 0 1 .066 1.414z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M11.999 24.001c-6.617 0-12-5.383-12-12s5.383-12 12-12 12 5.383 12 12-5.383 12-12 12zm0-23c-6.065 0-11 4.935-11 11s4.935 11 11 11 11-4.935 11-11-4.935-11-11-11z' }),
    _react2.default.createElement('path', { d: 'M18 18.001a.504.504 0 0 1-.338-.131l-6-5.5a.501.501 0 0 1-.162-.369v-5.5a.5.5 0 0 1 1 0v5.28l5.838 5.351a.498.498 0 0 1-.338.869z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 23.25C5.797 23.25.75 18.203.75 12S5.797.75 12 .75 23.25 5.797 23.25 12 18.203 23.25 12 23.25zm0-21c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25z' }),
    _react2.default.createElement('path', { d: 'M16.687 17.438a.743.743 0 0 1-.53-.22L11.47 12.53a.74.74 0 0 1-.163-.245l-.009-.025a.737.737 0 0 1-.047-.26V8.25a.75.75 0 0 1 1.5 0v3.439l4.467 4.468a.744.744 0 0 1 0 1.06.752.752 0 0 1-.531.221z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconTimeClockCircle.displayName = 'IconTimeClockCircle';
exports.default = IconTimeClockCircle;